import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorValues from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "title-div"
};
var _hoisted_2 = {
  class: "title-left"
};
var _hoisted_3 = {
  class: "title-right"
};
var _hoisted_4 = {
  class: "app-div",
  style: {
    "width": "100%",
    "height": "calc(100% - 24px)"
  }
};
var _hoisted_5 = {
  key: 0,
  class: "app-loading"
};
var _hoisted_6 = {
  key: 1,
  class: "app-content"
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  class: "img-div"
};
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  key: 0,
  class: "not-use"
};
var _hoisted_11 = {
  key: 1,
  class: "pop-num"
};
var _hoisted_12 = {
  key: 2,
  class: "pop-num"
};
var _hoisted_13 = {
  key: 3,
  class: "new-div"
};
var _hoisted_14 = {
  class: "item-name"
};
var _hoisted_15 = ["title"];
var _hoisted_16 = ["title"];
var _hoisted_17 = {
  key: 2,
  class: "app-empty"
};
import SortDialog from './AppSortDialog.vue';
import DisTimeDialog from './DisTimeDialog.vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { SearchIcon } from 'tdesign-icons-vue-next';
import { getAppBubbleByAlias, getAppUsable, getAppPage, getAppGroup } from '@/api/home.js';
import { appAliasEvent } from '@/utils/auth.js';
import { skipUrl as skipUrlOpen } from '@/util/util';
import { JumpToThird } from '@/util/thridExtends';
import { useRouter } from 'vue-router';
import $Bus from '@/util/bus';
import { validateNull } from '@/util/validate';
import { getStore, setStore } from '@/util/store';
import useNIMStore from '@/stores/modules/nim';
import { computed, watch, ref, onMounted } from 'vue';
export default {
  __name: 'AppList',
  props: {
    role: {
      type: String,
      default: 'manager'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    /**
     * 当前页面
     */
    var userInfo = getStore({
      name: 'userInfo'
    }); // 获取userInfo
    var accessToken = getStore({
      name: 'access_token'
    }); // 获取accessToken
    var router = useRouter();
    var useNIM = useNIMStore();

    // 问答应用红点数：云信初始化同步完成后才展示，避免本地缓存的过期未读数误报
    var qaUnread = computed(function () {
      return useNIM.qaUnread;
    });

    // 初始化相关
    var appList = ref([]); // 应用列表
    var canApplyApps = ref([]); // 可申请应用
    var applyApp = ref('');
    var searchKeyword = ref('');
    var hasSearched = ref(false);

    // 搜索过滤应用列表
    var handleSearch = function handleSearch() {
      hasSearched.value = true;
    };
    var handleClear = function handleClear() {
      searchKeyword.value = '';
      hasSearched.value = false;
    };
    var filteredAppList = computed(function () {
      if (!hasSearched.value) return appList.value;
      if (!searchKeyword.value) return appList.value;
      var keyword = searchKeyword.value.toLowerCase();
      return appList.value.filter(function (item) {
        return item.appDetail.name.toLowerCase().includes(keyword);
      });
    });
    watch(function () {
      return searchKeyword.value;
    }, function (val) {
      if (!val) hasSearched.value = false;
    });
    /**
     * 应用排序
     */
    var sortVisible = ref(false); // 应用排序弹窗显隐

    /**
     * 跳转app
     */
    var disVisible = ref(false);
    var appId = ref(null);
    var hasApplyAppAuth = computed(function () {
      return !validateNull(applyApp.value);
    }); // 是否有 应用申请 应用权限
    /**
     * 获取应用列表
     */
    var appLoading = ref(false);
    var getAppList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _res$data, code, data, _resData$find, resData, list, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              appLoading.value = true;
              _context.n = 1;
              return getAppGroup();
            case 1:
              res = _context.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (!(code === 0)) {
                _context.n = 2;
                break;
              }
              resData = data || [];
              list = ((_resData$find = resData.find(function (i) {
                return i.type === props.role;
              })) === null || _resData$find === void 0 ? void 0 : _resData$find.list) || [];
              console.log('list', list);
              setStore({
                name: 'userAppList',
                content: resData,
                type: 'session'
              });
              // 发出事件通知学生端tabs更新
              $Bus.emit('appListUpdated', resData);
              _context.n = 2;
              return getPopNum(list);
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              MessagePlugin.error((_t === null || _t === void 0 ? void 0 : _t.message) || '应用获取失败');
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[0, 3]]);
      }));
      return function getAppList() {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * 获取气泡数量
     */
    var getPopNum = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(list) {
        var apps, res, _res$data2, code, data, tempData, _loop, index, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              if (list.length) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              apps = list.map(function (i) {
                return i.appDetail.alias;
              });
              _context3.n = 2;
              return getAppBubbleByAlias(apps);
            case 2:
              res = _context3.v;
              _res$data2 = res.data, code = _res$data2.code, data = _res$data2.data;
              if (!(code === 0)) {
                _context3.n = 5;
                break;
              }
              appList.value = [];
              tempData = data || [];
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var _list$index, appDetail, useOfTimeControl, appItem, popItem, useState, isNew, num, unreadNum;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _list$index = list[index], appDetail = _list$index.appDetail, useOfTimeControl = _list$index.useOfTimeControl;
                      appItem = {
                        appDetail: appDetail,
                        useOfTimeControl: useOfTimeControl,
                        showNotUse: false,
                        isNew: false,
                        num: 0
                      };
                      popItem = tempData.find(function (i) {
                        return i.alias === appDetail.alias;
                      });
                      if (popItem) {
                        useState = popItem.useState, isNew = popItem.isNew, num = popItem.num;
                        unreadNum = Number(num) || 0;
                        appItem.showNotUse = !useState;
                        appItem.isNew = isNew;
                        appItem.num = unreadNum > 99 ? '99+' : unreadNum;
                      }
                      appList.value.push(appItem);
                    case 1:
                      return _context2.a(2);
                  }
                }, _loop);
              });
              index = 0;
            case 3:
              if (!(index < list.length)) {
                _context3.n = 5;
                break;
              }
              return _context3.d(_regeneratorValues(_loop()), 4);
            case 4:
              index++;
              _context3.n = 3;
              break;
            case 5:
              _context3.n = 7;
              break;
            case 6:
              _context3.p = 6;
              _t2 = _context3.v;
              console.log(_t2);
            case 7:
              _context3.p = 7;
              appLoading.value = false;
              return _context3.f(7);
            case 8:
              return _context3.a(2);
          }
        }, _callee2, null, [[0, 6, 7, 8]]);
      }));
      return function getPopNum(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    /**
     * 获取可申请应用列表
     */
    var getCanApplyApp = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, res, _res$data3, code, data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              params = {
                state: -1,
                memberType: props.role
              };
              _context4.n = 1;
              return getAppPage(params);
            case 1:
              res = _context4.v;
              _res$data3 = res.data, code = _res$data3.code, data = _res$data3.data;
              if (code === 0) {
                canApplyApps.value = data || [];
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee3);
      }));
      return function getCanApplyApp() {
        return _ref3.apply(this, arguments);
      };
    }();

    // 事件相关
    /**
     * 申请更多应用
     */
    var goApplyMoreApp = function goApplyMoreApp() {
      // 前往应用权限申请与管理应用
      var url = "".concat(applyApp.value, "?token=").concat(accessToken);
      skipUrlOpen(url);
    };
    var changeSort = function changeSort() {
      sortVisible.value = true;
    };
    var handleOpenApp = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(appDetail) {
        var res, _res$data4, code, data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!appDetail.showNotUse) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              if (!appDetail.useOfTimeControl) {
                _context5.n = 3;
                break;
              }
              _context5.n = 2;
              return getAppUsable(appDetail.id);
            case 2:
              res = _context5.v;
              _res$data4 = res.data, code = _res$data4.code, data = _res$data4.data;
              if (!(code === 0 && !data)) {
                _context5.n = 3;
                break;
              }
              // 应用不可用
              appId.value = appDetail.id;
              disVisible.value = true;
              return _context5.a(2);
            case 3:
              if (appDetail.source === 0) {
                if (appDetail.alias === 'inspirationCentre') {
                  skipUrlOpen(appDetail.url + '?inspirationCentre=%2Fsub-inspiration-centre-svc%2Fcourse');
                } else {
                  skipUrlOpen(appDetail.url);
                }
              } else {
                JumpToThird(appDetail, userInfo.value, accessToken, function (alias) {
                  if (alias.includes('boxiao')) {
                    router.push("/".concat(alias));
                  }
                });
              }
            case 4:
              return _context5.a(2);
          }
        }, _callee4);
      }));
      return function handleOpenApp(_x2) {
        return _ref4.apply(this, arguments);
      };
    }();
    var refreshPage = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              getCanApplyApp();
              _context6.n = 1;
              return getAppList();
            case 1:
              _context6.n = 2;
              return appAliasEvent('applyApp', false);
            case 2:
              applyApp.value = _context6.v;
            case 3:
              return _context6.a(2);
          }
        }, _callee5);
      }));
      return function refreshPage() {
        return _ref5.apply(this, arguments);
      };
    }();
    onMounted(function () {
      refreshPage();
    });
    return function (_ctx, _cache) {
      var _filteredAppList$valu, _filteredAppList$valu2, _filteredAppList$valu3;
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_loading = _resolveComponent("t-loading");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["app-list", __props.role])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "right-8"
      }, "应用 ", -1)), canApplyApps.value.length && hasApplyAppAuth.value ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        name: "add-circle",
        onClick: goApplyMoreApp
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_t_input, {
        modelValue: searchKeyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return searchKeyword.value = $event;
        }),
        placeholder: "请输入",
        clearable: "",
        class: "search-input",
        onInput: handleSearch,
        onEnter: handleSearch,
        onClear: handleClear
      }, {
        suffixIcon: _withCtx(function () {
          return [_createVNode(_unref(SearchIcon), {
            style: {
              cursor: 'pointer'
            },
            onClick: handleSearch
          })];
        }),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_svg_icon, {
        name: "sort",
        onClick: changeSort
      })])]), _createElementVNode("div", _hoisted_4, [appLoading.value && !((_filteredAppList$valu = filteredAppList.value) !== null && _filteredAppList$valu !== void 0 && _filteredAppList$valu.length) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_t_loading)])) : _createCommentVNode("", true), !appLoading.value && (_filteredAppList$valu2 = filteredAppList.value) !== null && _filteredAppList$valu2 !== void 0 && _filteredAppList$valu2.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAppList.value, function (_ref6, index) {
        var appDetail = _ref6.appDetail,
          useOfTimeControl = _ref6.useOfTimeControl,
          isNew = _ref6.isNew,
          showNotUse = _ref6.showNotUse,
          num = _ref6.num;
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["item-app", {
            not: showNotUse
          }]),
          onClick: function onClick($event) {
            return handleOpenApp(_objectSpread(_objectSpread({}, appDetail), {}, {
              showNotUse: showNotUse,
              useOfTimeControl: useOfTimeControl
            }));
          }
        }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
          src: appDetail.icon,
          fit: "cover",
          class: _normalizeClass(["item-icon", {
            'disabled-img': showNotUse
          }])
        }, null, 10, _hoisted_9), __props.role === 'teacher' || __props.role === 'student' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [showNotUse ? (_openBlock(), _createElementBlock("div", _hoisted_10, "不可用")) : num && appDetail.alias !== 'chatQa' ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(num || 0), 1)) : appDetail.alias === 'chatQa' && qaUnread.value > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(qaUnread.value > 99 ? '99+' : qaUnread.value), 1)) : isNew ? (_openBlock(), _createElementBlock("div", _hoisted_13, "new")) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("p", {
          class: "name",
          title: appDetail.name
        }, _toDisplayString(appDetail.name), 9, _hoisted_15), __props.role === 'manager' ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "item-desc",
          title: appDetail === null || appDetail === void 0 ? void 0 : appDetail.tagline
        }, _toDisplayString((appDetail === null || appDetail === void 0 ? void 0 : appDetail.tagline) || ''), 9, _hoisted_16)) : _createCommentVNode("", true)])], 10, _hoisted_7);
      }), 128))])) : _createCommentVNode("", true), !appLoading.value && !((_filteredAppList$valu3 = filteredAppList.value) !== null && _filteredAppList$valu3 !== void 0 && _filteredAppList$valu3.length) ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(hasSearched.value ? '暂无相关应用，你可尝试更换搜索词' : '暂无应用'), 1)) : _createCommentVNode("", true)]), _createVNode(SortDialog, {
        sortVisible: sortVisible.value,
        "onUpdate:sortVisible": _cache[1] || (_cache[1] = function ($event) {
          return sortVisible.value = $event;
        }),
        "tab-type": __props.role,
        onRefresh: getAppList
      }, null, 8, ["sortVisible", "tab-type"]), _createVNode(DisTimeDialog, {
        disVisible: disVisible.value,
        "onUpdate:disVisible": _cache[2] || (_cache[2] = function ($event) {
          return disVisible.value = $event;
        }),
        appId: appId.value
      }, null, 8, ["disVisible", "appId"])], 2);
    };
  }
};